import * as React from 'react';
import './index.scss';

interface Props {
    children?: React.ReactNode;
    onClick?: () => void;
}

const ButtonLine = (props: Props) => (
    <button className="btn-line" onClick={props.onClick}>{props.children}</button>
);

export default ButtonLine;


// WEBPACK FOOTER //
// ./src/components/layout/buttons/LineButton/index.tsx